export const stylesRefs = {
  header: 'Header_header',
  sticky: 'Header_sticky',
} as const
